interface OTPVerificationStepProps {
  email: string;
  verificationCode: string;
  isLoading: boolean;
  onCodeChange: (value: string) => void;
  onSubmit: () => void;
  onResendCode?: () => void;
  className?: string;
}

export function OTPVerificationStep({ 
  email,
  verificationCode, 
  isLoading,
  onCodeChange, 
  onSubmit,
  onResendCode,
  className = '' 
}: OTPVerificationStepProps) {
  
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSubmit();
  };

  const handleCodeInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value.replace(/[^0-9]/g, ''); // 숫자만 허용
    if (value.length <= 6) {
      onCodeChange(value);
    }
  };

  return (
    <form onSubmit={handleSubmit} className={`space-y-6 ${className}`}>
      {/* 발송된 이메일 표시 */}
      <div className="text-center mb-6">
        <p className="text-[14px] text-gray-600 mb-2">
          인증번호를 발송했습니다
        </p>
        <div className="bg-gray-50 border border-gray-200 rounded-lg p-3">
          <p className="text-[14px] font-medium text-[#222222] break-all">
            {email}
          </p>
        </div>
        <p className="text-[12px] text-gray-500 mt-2">
          메일이 오지 않았다면 스팸메일함을 확인해보세요
        </p>
      </div>

      {/* 인증번호 입력 */}
      <div>
        <label className="block text-[16px] font-medium text-[#222222] mb-3">
          인증번호 (6자리)
        </label>
        <input
          type="text"
          value={verificationCode}
          onChange={handleCodeInput}
          placeholder="000000"
          maxLength={6}
          className="w-full h-[50px] px-4 text-[18px] text-center font-mono border-[1.5px] border-[#DEDEDE] rounded-xl focus:outline-none focus:border-[#51C854] placeholder:text-[#999999] tracking-widest"
        />
        <p className="text-[12px] text-gray-500 mt-2">
          6자리 숫자를 입력해주세요
        </p>
      </div>

      {/* 인증 확인 버튼 */}
      <button
        type="submit"
        disabled={isLoading || verificationCode.length !== 6}
        className="w-full h-[50px] bg-[#51C854] text-white font-semibold text-[16px] rounded-xl hover:bg-[#46B649] disabled:bg-gray-300 disabled:cursor-not-allowed transition-colors"
      >
        {isLoading ? '확인 중...' : '인증번호 확인'}
      </button>

      {/* 재발송 버튼 */}
      {onResendCode && (
        <button
          type="button"
          onClick={onResendCode}
          className="w-full h-[40px] text-[#51C854] font-medium text-[14px] hover:text-[#46B649] transition-colors"
        >
          인증번호 재발송
        </button>
      )}
    </form>
  );
}